$(function() {
  if($('.checkbox-edit--1').length) {
    /*
    ▲親checkboxがcheckedになったら子checkboxもcheckedに変化
    */
    $('.checkbox-edit-all').on('click', function() {
      if($(this).find('.js-edit-all').prop('checked')) {
        $(this).parent('.checkbox-edit--1').children('.checkbox-edit-list').find('.checkbox-edit-input').prop('checked', true);
      }else{
        $(this).parent('.checkbox-edit--1').children('.checkbox-edit-list').find('.checkbox-edit-input').prop('checked', false);
      };
    });
    /*
    ▼checkedの子checkboxがない時にグループの親checkboxのcheckedを解除
    */
    $('.checkbox-edit--1 .checkbox-edit-list').off('click');
    $('.checkbox-edit--1 .checkbox-edit-list').on('click', function () {
      if($(this).find(':checked').length == $(this).find('input').length) {
        let parentCheckbox = $(this).parent('.checkbox-edit--1 ').find('.checkbox-edit-all').find('.js-edit-all');
        if (parentCheckbox.prop("checked") == true) {
          parentCheckbox.prop('checked', false);
        } else {
          parentCheckbox.prop('checked', true);
        }
      }
    });
  }
  $('.js-edit-all:checked').closest('.checkbox-edit--1').find('.checkbox-edit-list input').prop('checked', true);
});



$(function () {
  if($('.priority-box-wrap').length) {
    $(document).on('click', '.checkbox', function () {
      let chkLength = $(this).closest('.priority-box-wrap').find('.checkbox:checked').length;
      if (chkLength > 3) {
        // 3つより多くチェックが入る場合は中止
        return false;
      }
      let selectedNo = Number($(this).closest('label').find('.no').text());
      if ($(this).prop('checked')) {
        /**
         * チェック入れた時
         */
        $(this).closest('label').find('.no').text(chkLength);
        $(this).closest('label').find('.no').attr('data-number', chkLength);
      } else {
        /**
         * チェック外した時
         */
        // 採番し直し
        $('.priority-box-wrap .checkbox').each(function (index) {
          let no = Number($(this).closest('label').find('.no').text());
          if (no != '' && selectedNo < no) {
            $(this).closest('label').find('.no').text(no - 1);
            $(this).closest('label').find('.no').attr('data-number', no - 1);
          }
        });
        // チェック外したNoを削除
        $(this).closest('label').find('.no').text('');
        $(this).closest('label').find('.no').attr('data-number', '');
      }
      /**
       * priorityの編集
       */
      let maxNo = 0;
      $('.priority-box-wrap .checkbox').each(function (index) {
        let checkedValue = $(this).val();
        let no = Number($(this).closest('label').find('.no').text());
        if (no != '') {
          $('input[name="priority_' + no + '"]').val(checkedValue);
          if (maxNo < no) {
            maxNo = no;
          }
        }
      });
      $('.priority-group .priority-hidden').each(function (index) {
        if (maxNo < $(this).data('no')){
          $(this).val('');
        }
      });
    });
  }
});

$(function () {
	// ▼※を必須マークに変換
	if ($('.mypage, #modal-profile-img').length > 0) {
		$('label').each(function () {
			let dataname = $(this).html();
			let brank = "※";
			let regExp = new RegExp(brank, "g");
			let name = dataname.replace(regExp, '<span class="required">必須</span>');
			$(this).html(name);
		});
	};
  if($('.skill-header').length) {
    $('.add').on('click', function () {
      if($('.in-de-crease').length < 5) {
        var clone = $(this).parent().parent().clone(true);
        clone.find("option").prop('selected',false);
        clone.insertAfter($(this).parent().parent());
      }
    });
    $('.del').on('click', function () {
      var target = $(this).parent().parent('.in-de-crease');
      if (target.parent().children('.in-de-crease').length > 1) {
        target.remove();
      }
    });
  }
});
if($('.js-number-text-400').length) {
  $(window).on('load', function() {
    var count = $('.js-number-text-400').prev('textarea').val().length;
    $('#js-number-text-content-400').text(count);
  });
}
if($('.js-number-text-300').length) {
  $(window).on('load', function() {
    var count = $('.js-number-text-300').prev('textarea').val().length;
    $('#js-number-text-content-300').text(count);
  });
}
if($('.js-number-text-100').length) {
  $(window).on('load', function() {
    var count = $('.js-number-text-100').prev('textarea').val().length;
    $('#js-number-text-content-100').text(count);
  });
}
